import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotSplitDialogTourConfig: AgTechTourConfig = {
    id: 'lot-split-dialog-tour',
    name: 'Split Lot Tour',
    steps: [
        {
            targetId: 'lot-split-add-contact',
            skipIfMissing: true,
            title: 'Add a Contact',
            description: 'Add each contact who shares ownership of this lot. Contacts already in the split are not offered again.',
            position: 'bottom',
        },
        {
            targetId: 'lot-split-grid',
            title: 'Split Percentages',
            description: 'Enter the percentage of the lot each contact owns. Bidder Number shows whether the contact is registered in this sale. Submit when the percentages are correct to split the lot.',
            position: 'top',
        },
    ]
}
